export const COUNTRY_CODE_GET_SUCCESS = 'COUNTRY_CODE_GET_SUCCESS';
export const COUNTRY_CODE_GET_FAIL = 'COUNTRY_CODE_GET_FAIL';
export const COUNTRY_CODE_GET_REQUEST = 'COUNTRY_CODE_GET_REQUEST';
export const COUNTRY_CODE_SUCCESS_MESSAGE = 'COUNTRY_LISTED_SUCCESSFULLY';
